/** ix: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  needLabel: 'Give this interaction a name.',
  needHotspot: 'Draw at least one hotspot on the preview.',
  needUrl: "Enter the page's address, starting with https://",
  secondsRange: 'Between {min} and {max} seconds.',
  needClose: 'A page that stays until closed needs the close button.',
  where: 'Where',
  returnHint: 'When the screen goes back to its normal content.',
  fixFields: 'Fix the highlighted fields to continue.',
  whileX: 'Applies while {name} is on screen.',
  sUnit: 's',
  ownerPlayer: 'Player · {name}',
  ownerCampaign: 'Campaign · {name}',
  press: '🎛 Press {key}',
  tapZone: '👆 Tap zone {name}',
  tapHotspots: '👆 Tap {n} hotspot | 👆 Tap {n} hotspots',
  backAfter: 'back after {n} s',
  fromCampaign: 'from campaign {name}',
  onlyWhileX: '· only while {name} plays',
  hotspotN: 'Hotspot {n}',
  drawHint: 'Drag on the preview to draw a hotspot ({n}/10). Select one to edit it.',
  chooseContent: 'Choose the content to play.',
  chooseApplies: 'Choose the content it applies to.',
  checkForm: 'Check the form',
  edit: 'Edit interaction',
  new: 'New interaction',
  label: 'Label',
  labelPh: 'e.g. Tap for the menu',
  enabled: 'Enabled',
  when: 'When',
  trigger: 'Trigger',
  touch: '👆 Touch',
  remote: '🎛 Remote key',
  anywhere: 'Anywhere on screen',
  zoneOpt: 'A zone of this campaign',
  hotspotsOpt: 'Hotspots I draw',
  zone: 'Zone',
  key: 'Key',
  remoteKey: 'Remote key',
  keyHint: 'For TV boxes with a remote; OK also matches Enter.',
  appliesTo: 'Applies to',
  anyContent: 'Any content on this player',
  onlyWhile: 'Only while this content plays',
  then: 'Then',
  action: 'Action',
  play: '▶ Play content',
  web: '🌐 Open web page',
  backToList: 'Back to the list',
  after: 'after',
  seconds: 'Seconds',
  whenEnds: 'when it ends',
  url: 'Web page URL',
  onlyClosed: 'only when closed',
  closeBtn: 'Show a close button (✕) so viewers can go back',
  cancel: 'Cancel',
  create: 'Create interaction',
  saveChanges: 'Save changes',
  saving: 'Saving…',
  tapAnywhere: '👆 Tap anywhere',
  untilClosed: ' · until closed',
  backWhenEnds: 'back when it ends',
  deletedContent: 'deleted content',
  off: 'Off',
  editBtn: 'Edit',
  delete: 'Delete',
  remove: 'Remove',
};
const ar: typeof en = {
  needLabel: 'أدخل اسماً لهذا التفاعل.',
  needHotspot: 'ارسم نقطة تفاعل واحدة على الأقل في المعاينة.',
  needUrl: 'أدخل عنوان الصفحة بدءاً بـ https://',
  secondsRange: 'بين {min} و{max} ثانية.',
  needClose: 'الصفحة التي تبقى حتى تُغلق تحتاج زر الإغلاق.',
  where: 'المكان',
  returnHint: 'متى تعود الشاشة إلى محتواها المعتاد.',
  fixFields: 'صحّح الحقول المحددة للمتابعة.',
  whileX: 'ينطبق أثناء ظهور {name} على الشاشة.',
  sUnit: 'ث',
  ownerPlayer: 'المشغل · {name}',
  ownerCampaign: 'الحملة · {name}',
  press: '🎛 اضغط {key}',
  tapZone: '👆 المس القسم {name}',
  tapHotspots:
    '👆 المس نقاط التفاعل | 👆 المس نقطة تفاعل واحدة | 👆 المس نقطتي تفاعل | 👆 المس {n} نقاط تفاعل | 👆 المس {n} نقطة تفاعل | 👆 المس {n} نقطة تفاعل',
  backAfter: 'العودة بعد {n} ث',
  fromCampaign: 'من الحملة {name}',
  onlyWhileX: '· فقط أثناء عرض {name}',
  hotspotN: 'نقطة التفاعل {n}',
  drawHint: 'اسحب على المعاينة لرسم نقطة تفاعل ({n}/١٠). حدّد إحداها لتعديلها.',
  chooseContent: 'اختر المحتوى المراد عرضه.',
  chooseApplies: 'اختر المحتوى الذي ينطبق عليه.',
  checkForm: 'تحقق من النموذج',
  edit: 'تعديل التفاعل',
  new: 'تفاعل جديد',
  label: 'التسمية',
  labelPh: 'مثل: المس لعرض القائمة',
  enabled: 'مفعّل',
  when: 'عندما',
  trigger: 'المُشغِّل',
  touch: '👆 لمس',
  remote: '🎛 زر جهاز التحكم',
  anywhere: 'أي مكان على الشاشة',
  zoneOpt: 'قسم من هذه الحملة',
  hotspotsOpt: 'نقاط تفاعل أرسمها',
  zone: 'القسم',
  key: 'الزر',
  remoteKey: 'زر جهاز التحكم',
  keyHint: 'لأجهزة التلفاز ذات جهاز التحكم؛ OK يطابق Enter أيضًا.',
  appliesTo: 'ينطبق على',
  anyContent: 'أي محتوى على هذا المشغل',
  onlyWhile: 'فقط أثناء عرض هذا المحتوى',
  then: 'ثم',
  action: 'الإجراء',
  play: '▶ عرض محتوى',
  web: '🌐 فتح صفحة ويب',
  backToList: 'العودة إلى القائمة',
  after: 'بعد',
  seconds: 'الثواني',
  whenEnds: 'عند انتهائه',
  url: 'رابط صفحة الويب',
  onlyClosed: 'عند الإغلاق فقط',
  closeBtn: 'إظهار زر إغلاق (✕) ليتمكن المشاهدون من العودة',
  cancel: 'إلغاء',
  create: 'إنشاء تفاعل',
  saveChanges: 'حفظ التغييرات',
  saving: 'جارٍ الحفظ…',
  tapAnywhere: '👆 المس أي مكان',
  untilClosed: ' · حتى الإغلاق',
  backWhenEnds: 'العودة عند الانتهاء',
  deletedContent: 'محتوى محذوف',
  off: 'متوقف',
  editBtn: 'تعديل',
  delete: 'حذف',
  remove: 'إزالة',
};
export default { en, ar };
